import { type GameOverScreenHandle, createGameOverScreen } from '@fg/ui-kit';
import Phaser from 'phaser';

export class GameOverScene extends Phaser.Scene {
  private overlay: GameOverScreenHandle | null = null;

  constructor() {
    super('gameover');
  }

  create(): void {
    const score = (this.registry.get('game-over-score') as number) ?? 0;
    const prevBest = (this.registry.get('game-over-prev-best') as number) ?? 0;
    this.overlay = createGameOverScreen({
      score,
      previousBest: prevBest,
      onReplay: () => {
        this.overlay?.destroy();
        this.scene.stop('game');
        this.scene.start('game');
        this.scene.stop();
      },
      onMenu: () => {
        this.overlay?.destroy();
        this.scene.stop('game');
        this.scene.start('title');
        this.scene.stop();
      },
      onShare: () => {
        const text = `I scored ${score.toLocaleString()} in Fruit Game! ${location.href}`;
        const nav = navigator as Navigator & {
          share?: (data: ShareData) => Promise<void>;
          clipboard?: { writeText: (s: string) => Promise<void> };
        };
        if (typeof nav.share === 'function') {
          void nav.share({ title: 'Fruit Game', text }).catch(() => {});
        } else {
          void nav.clipboard?.writeText(text);
        }
      },
    });
    document.body.appendChild(this.overlay.el);
    this.overlay.show();

    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
      this.overlay?.destroy();
      this.overlay = null;
    });
  }
}
